module.exports = __webpack_public_path__ + "img/rainCloud.70008423.svg";